import { AxiosRequestConfig } from 'axios';
import { axiosClient } from '@as-react/common-utils';
import { SearchContent, SearchSuggestions } from '@as-react/common-types';
import { QueryApiOptions, UrlMapping } from '../../types/types';
import { searchQueryKeys } from './search.queries';
import { createUrl } from '../../utils/createUrl';

export type SearchSuggestionsParams = {
  query: string;
};

export type SearchContentSuggestionParams = {
  query: string;
  elasticsearchIndex: string;
};

const searchEndpoints: UrlMapping<typeof searchQueryKeys> = {
  SearchSuggestions: {
    client: 'api/aem/search/suggestion',
  },
  SearchContentSuggestion: {
    client: 'api/aem/search/suggestion/content',
  },
};

export const getSearchSuggestions = async (
  { servicesEndpoint, isServer, defaultRequestParams }: QueryApiOptions,
  { query }: SearchSuggestionsParams
): Promise<SearchSuggestions> => {
  const url = createUrl(servicesEndpoint, searchEndpoints.SearchSuggestions, isServer);
  const axiosConfig: AxiosRequestConfig = {
    method: 'GET',
    url,
    params: {
      query,
      mainWebshop: defaultRequestParams.mainWebshop,
      language: defaultRequestParams.language,
    },
    withCredentials: true,
  };

  const result = await axiosClient.request(axiosConfig);
  return result.data;
};

export const getSearchContentSuggestion = async (
  { servicesEndpoint, isServer }: Omit<QueryApiOptions, 'defaultRequestParams'>,
  { elasticsearchIndex, query }: SearchContentSuggestionParams
): Promise<SearchContent> => {
  const url = createUrl(servicesEndpoint, searchEndpoints.SearchContentSuggestion, isServer);
  const axiosConfig: AxiosRequestConfig = {
    method: 'GET',
    url,
    params: {
      index: elasticsearchIndex,
      q: query,
    },
    withCredentials: true,
  };

  const result = await axiosClient.request(axiosConfig);
  return result.data;
};
